import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FormProvider, useForm } from 'react-hook-form';
import { useMyTranslations } from '@hooks/useMyTranslations';
import { useStore } from '@hooks/useStore';
import { AddEntityButton } from '@components/Core/AddEntityButton';
import { PageHeader } from '@components/Core/PageHeader';
import { Input } from '@inputs/Input';
import { BrandsTable } from '@tables/BrandsTable/BrandsTable';
import { BrandsTransFields } from './types';
import { brandsTranslations } from './translations';

function Brands() {
  const {
    pointsStore: { setPointsList },
  } = useStore();

  useEffect(() => {
    setPointsList([]);
  }, []);

  const { t } = useMyTranslations<BrandsTransFields>([brandsTranslations.name]);
  const navigate = useNavigate();

  const useFormMethods = useForm<{ search: string }>();
  const { watch } = useFormMethods;

  return (
    <div className="page-container">
      <PageHeader text={t('brands')} />
      <div className="flex flex-row justify-between items-center px-[48px] sm-page-padding gap-x-[24px] max-md:gap-x-[12px]">
        <FormProvider {...useFormMethods}>
          <Input name="search" type="text" placeholder={t('search')} />
        </FormProvider>
        <AddEntityButton text={t('addBrand')} onClick={() => navigate('/add-brand')} />
      </div>
      <BrandsTable search={watch('search')} />
    </div>
  );
}

export default Brands;
